var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDestinationPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EDE8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_25076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 12.0498H16.7758C16.5598 9.7638 14.7358 7.9338 12.4498 7.7238V6.4998C12.4498 6.2538 12.2458 6.0498 11.9998 6.0498C11.7538 6.0498 11.5498 6.2538 11.5498 6.4998V7.7238C9.2638 7.9398 7.4338 9.7638 7.2238 12.0498H5.9998C5.7538 12.0498 5.5498 12.2538 5.5498 12.4998C5.5498 12.7458 5.7538 12.9498 5.9998 12.9498H7.2238C7.4398 15.2358 9.2638 17.0658 11.5498 17.2758V18.4998C11.5498 18.7458 11.7538 18.9498 11.9998 18.9498C12.2458 18.9498 12.4498 18.7458 12.4498 18.4998V17.2758C14.7358 17.0598 16.5658 15.2358 16.7758 12.9498H17.9998C18.2458 12.9498 18.4498 12.7458 18.4498 12.4998C18.4498 12.2538 18.2458 12.0498 17.9998 12.0498ZM11.9998 14.3718C10.9678 14.3718 10.1278 13.5318 10.1278 12.4998C10.1278 11.4678 10.9678 10.6278 11.9998 10.6278C13.0318 10.6278 13.8718 11.4678 13.8718 12.4998C13.8718 13.5318 13.0318 14.3718 11.9998 14.3718Z",
    fill: "#38008F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_25076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.7998 5.2998)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationPoint);
export default __webpack_public_path__ + "static/media/destination-point.04825fe49950b4e2c5c680fa50bd56b7.svg";
export { ForwardRef as ReactComponent };